import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ComputedRef, computed } from "vue";
import { useStore } from "vuex";
import TwLabel from "../TwLabel.vue";
import TwButtonsYesAndNo from "../TwButtonsYesAndNo.vue";


export default /*#__PURE__*/_defineComponent({
  __name: '11.ExperienceOilyShine',
  setup(__props) {

const store = useStore();

const experienceOilyShine: ComputedRef<boolean> = computed(
  () => store.state.form.experience_oily_shine
);
const updateExperienceOilyShine = (value: boolean) => {
  store.dispatch("updateExperienceOilyShine", value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[experienceOilyShine.value == null ? 'bg-red-500' : ''], "p-2"])
  }, [
    _createVNode(TwLabel, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("experience_oily_shine")), 1)
      ]),
      _: 1
    }),
    _createVNode(TwButtonsYesAndNo, {
      isActive: experienceOilyShine.value,
      onOnClickYes: _cache[0] || (_cache[0] = ($event: any) => (updateExperienceOilyShine(true))),
      onOnClickNo: _cache[1] || (_cache[1] = ($event: any) => (updateExperienceOilyShine(false)))
    }, null, 8, ["isActive"])
  ], 2))
}
}

})